<ul class="text-mobileMd tablet:text-tabletMd desktop:text-desktopMd bg-white" role="list">
  @for (msisdn of msisdnList(); track $index) {
    <li
      #msisdnItem
      (click)="selectMsisdn(msisdn)"
      class="flex items-center gap-x-3 p-3 rounded"
      [class.bg-neutral100]="currentCustomerId() === msisdn.customerId"
      role="listitem"
    >
      <button
        (click)="$event.stopPropagation(); selectMsisdn(msisdn)"
        class="h-6 w-6 border-2 border-[#616161] flex justify-center items-center rounded-full"
      >
        @if (currentCustomerId() === msisdn.customerId) {
          <div class="bg-black h-[14px] w-[14px] rounded-full"></div>
        }
      </button>
      <div>
        <div
          class="font-semibold cursor-pointer flex items-center justify-between text-sm tablet:text-base gap-x-3 group"
          scClickToCopy="{{ msisdn.msisdn }}"
        >
          <div>
            {{
              msisdn.isTerminated
                ? msisdn.isJottaInUse
                  ? ('shared.letsGoCloud' | scTranslate | async)
                  : ('shared.terminated' | scTranslate | async)
                : (msisdn.msisdn | scMsisdn | scTranslate | async | scPhoneNumber)
            }}
          </div>
        </div>
        <div class="text-mobileSm leading-4 tablet:text-tabletSm desktop:text-desktopSm">
          @if (!msisdn.isTerminated) {
            {{ msisdn.description }}
          }
        </div>
      </div>
    </li>
  }
</ul>
